<template>
<div
    class="p-3 mr-3" 
    :style="{backgroundColor: this.responsibleprop ? '#f1f1f1' : '#fff'}"
>
    <div>
        <h4
            :data-toggle="`${this.responsibleprop ? 'collapse' : ''}`"
            :data-target="`#member--info__${member.id}`"
            role="button"
            aria-expanded="false"
            :aria-controls="`#member--info__${member.id}`"
            :style="`${this.responsibleprop ? 'cursor:pointer;' : ''}`"
            @click="toggle"
        >
            <i 
                style="float:right;"
                v-if="this.responsibleprop"
                class="fas fa-angle-down"
                :class="{'fas fa-angle-up' : open}"></i>
            {{member.first_name}} {{member.last_name}}
        </h4>
    </div>
    <div
        id="`member--info__${member.id}`"
        :class="{collapse: this.responsibleprop && !open}"
    >
        <div>
            nato il {{getDateFormatted(member.birthday)}}
            {{member.municipality_birth ? ` a ${member.municipality_birth}` : ''}}
            {{member.province_birth ? ` (${member.province_birth})` : ''}}
            {{member.region_birth ? ` in ${member.region_birth}` : ''}}
            {{member.country_birth ? ` (${member.country_birth})` : ''}}
        </div>
        <div 
            v-if="member.nationality"
            class="mt-2"
        >
            <strong>Nazionalità:</strong> {{member.nationality === 'italian' ? 'Italiana' : 'Estera'}}
        </div>
        <div 
            v-if="member.address"
            class="mt-2"
        >
            <strong>Indirizzo:</strong> 
            {{member.address ? `${member.address}` : ''}}{{member.house_number ? `, ${member.house_number}` : ''}}
            {{member.municipality ? ` - ${member.municipality}` : ''}}
            {{member.province ? ` (${member.province})` : ''}}
            {{member.region ? ` in ${member.region}` : ''}}
            {{member.country ? ` (${member.country})` : ''}}
        </div>
        <div class="mt-2">
            <strong>Codice fiscale:</strong> {{member.fiscal_code ? member.fiscal_code.toUpperCase() : 'Mancante'}}
        </div>
        <div v-if="member.document_type && member.document_number">
            <h4 class="mt-3">
                Documento di riconoscimento
            </h4>
            <div class="mt-2">
                {{ucfirst(member.document_type)}} n. {{ucfirst(member.document_number)}} 
                {{ `${member.document_released_by ? ' rilasciato da ' + member.document_released_by : ''}` }}
                {{ `${member.document_released_at ? ' il ' + getDateFormatted(member.document_released_at) : ''}` }}
                {{ `${member.document_expired_at ? ', scade il ' + getDateFormatted(member.document_expired_at) : ''}` }}
            </div>
        </div>
        <div v-if="member.email || member.phone">
            <h4 class="mt-3">
                Contatti
            </h4>
            <div>
                <strong>Email:</strong> {{member.email}}
            </div>
            <div>
                <strong>Telefono:</strong> {{member.phone}}
            </div>
        </div>
        <div v-if="member.medical_visit == 1">
            <h4 class="mt-3">
                Visita medica
            </h4>
            <div v-if="member.medical_visit_expiration">
                <strong>Valida fino al:</strong>
                <span>{{ getDateFormatted(member.medical_visit_expiration) }}</span>
            </div>
            <div v-if="member.medical_visit_type">
                <strong>Tipo:</strong>
                <span>{{ member.medical_visit_type }}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment'

export default {
    name: "UserCompanyMember",
    props: {
        memberprop: Object,
        responsibleprop: Object
    },
    data() {
        const member = this.memberprop
        const responsible = this.responsibleprop

        return { 
            open: false,
            member,
            responsible
        }
    },
    mounted() {
        console.log(this.member)
        console.log(this.responsible)
    },
    methods: {
        getDateFormatted(date) {
            return moment(date).format("DD/MM/YYYY")
        },
        ucfirst(str) {
            return str.charAt(0).toUpperCase() + str.slice(1)
        },
        toggle() {
            this.open = !this.open
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/user/UserCompanyMember.vue